module.exports = __webpack_public_path__ + "img/632.A_dripping_faucet.d52ddc84.svg";